import Vue from 'vue';
import { eventBus, SAMPLE_PRINTED } from '@/api/eventbus';

import Cookies from 'universal-cookie';

const cookies = new Cookies();
let cookieConfig = {};
let cookieDomain = '';

if (cookieConfig !== '') {
  cookieConfig = {
    domain: cookieDomain,
    path: '/',
    maxAge: maxAgeCookie(),
    expires: expireCookie(365),
  };
}

function expireCookie(days) {
  let date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date;
}

function maxAgeCookie() {
  return 3600;
}

function getCounters() {
  let cookie = getCookie('feedback');
  if (cookie) {
    return cookie;
  }
  return {
    SAMPLE_PRINTED: 0,
  };
}

function saveCookie(name, value) {
  cookies.set(name, value, cookieConfig);
}

function getCookie(name) {
  return cookies.get(name);
}

const feedbackMapping = {
  'full-system': {
    counter: SAMPLE_PRINTED,
    limit: 20,
  },
};

const feedback = new Vue({
  data: () => {
    return {
      feedbackCounters: getCounters(),
      feedbackInProgress: '',
    };
  },
  watch: {
    feedbackCounters: {
      handler: function () {
        saveCookie('feedback', this.feedbackCounters);
      },
      deep: true,
    },
  },
  created() {
    let self = this;
    // listen for the available counters
    for (var key in feedbackMapping) {
      if (feedbackMapping.hasOwnProperty(key)) {
        var element = feedbackMapping[key];
        let counter = element.counter.slice(0);

        eventBus.$on(counter, function () {
          self.incrementCounter(counter);
        });
      }
    }
  },
  methods: {
    setFeedbackInProgress(feature) {
      this.feedbackInProgress = feature;
    },
    incrementCounter(feature) {
      if (this.$toggle.feature.feedback) {
        this.feedbackCounters[feature]++;
      }
    },
    resetCounter(feature) {
      this.feedbackCounters[feature] = 0;
    },
  },
});

window.feedbackCounters = feedback.feedbackCounters;

export default feedback;

export { feedback, feedbackMapping };
